import React from "react";
import Hex from "../assets/sloth/hex.png"
import JoinTheClub from "../components/smsc/JoinTheClub";
import Grass from "./Grass";
import { Fade, Flip } from "react-awesome-reveal";

const GrassSection = (props) => {
    return(
        <div className={`w-screen h-fit text-[#0D3727] ${props.rotate ? `rotate-180 translate-y-[-2px]` : `translate-y-[2px]`}`}>
            <Grass/>
        </div>
    )
}

const Sanctuary = () => {
  return (
    <>
        <GrassSection/>
      <section className="bg-[#0D3727] text-[#E6FFF1]">
        
        <div className="pt-[30px] pb-[40px] lg:py-[107px] container-theme text-center">
        <Fade cascade duration={300}>
        <h3 className="h3 uppercase" id="sanctuary">
          Welcome to <br className='hidden lg:block' />
          The Sanctuary
        </h3>

        <div className="grid lg:grid-cols-12 pt-[30px] lg:pt-[95px] lg:gap-[70px]">
            <div className='lg:col-span-6'>
                <p className="body-1 text-left lg:max-w-[40vw]">
                <strong>Slow Mo Sloth Club is an NFT collection of the 6,000 most philosophical creatures living on the Ethereum blockchain.</strong>
 <br/> <br/>

 This NFT project was created to build a community of people who want to help animal species. Early adopters of the project were to be handsomely rewarded for laying the foundations of this wildlife hub, and with time and more members, the intention was to welcome more struggling creatures.
 <br/> <br/>

 While this project has ended, you can still head to Opensea to see some of the sloths released.
</p>

</div>
<div className="lg:col-span-6 flex flex-col items-center justify-center lg:order-first pt-[40px] lg:pt-0">
  <Flip>
                <img src={Hex} className='w-1/2 mx-auto lg:w-full lg:max-w-[24vw]'/>
                </Flip>
            </div>

        </div>
        </Fade>
        </div>

      </section>
      <GrassSection rotate/>

    </>
  );
};

export default Sanctuary
